import axiosInstance from "../../../interceptors/axiosInstance";
import { AxiosResponse } from "axios";
import { Dominios } from "../../../utils/enums";
import { DataContabilizacionRecaudacionDividendoToSubmit, DataRecaudacionToSubmit, ParametrosRecalculo } from "../models/mutuoRecaudar";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { Recaudador } from "../models/recaudador";
import { selectorTransversal } from "../../../dtos/selector";

export interface EsMutuoRecaudableResponse {
  esMutuoRecaudable: boolean;
}

const BASE_PATH_API_RECAUDACION = 'siscred-api-recaudacion/v1';
const BASE_PATH_API_CONTABILIZACION = 'siscred-api-contabilizacion/v1';
const BASE_PATH_API_TRANSVERSAL = 'siscred-api-transversal/v1';

export const getMutuoRecaudar = (mutuoId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/mutuo-recaudar`, {
    params: { mutuoId }
  });

export const postMutuoRecaudar = (dataRecaudacion: DataRecaudacionToSubmit): Promise<AxiosResponse> =>
  axiosInstance.post(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/recaudar-dividendo`, dataRecaudacion);

export const postContabilizarRecaudacion = (dataRegistroContabilidadRecaudacion: DataContabilizacionRecaudacionDividendoToSubmit): Promise<AxiosResponse> =>
  axiosInstance.post(`${BASE_PATH_API_CONTABILIZACION}/contabilidad/registraroperaciondividendo`, dataRegistroContabilidadRecaudacion);

export const postMutuoDeshacerRecaudacion = (mutuoId: number, numeroDividendo: number): Promise<AxiosResponse> =>
  axiosInstance.post(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/deshacer-ultima-recaudacion`, { mutuoId, numeroDividendo });

export const getRecaudadores = (): Promise<AxiosResponse<ListResponseDto<Recaudador>>> =>
  axiosInstance.get<ListResponseDto<Recaudador>>(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/recaudadores-activo`);

export const getRecalcularMontos = (parametrosRecalcular: ParametrosRecalculo): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/recalcular-montos`, {
    params: parametrosRecalcular
  });

export const getParametroByCodigo = (codigo: string): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/parametro`, {
    params: { codigo }
  });

export const getFormasPago = (codigoDominio: Dominios): Promise<AxiosResponse<ListResponseDto<selectorTransversal>>> =>
  axiosInstance.get(`${BASE_PATH_API_TRANSVERSAL}/dominio/obtener-datos-dominio`, {
    params: { codigoDominio }
  });

export const getMutuoDeshacerRecaudacion = (mutuoId: number): Promise<AxiosResponse> =>
  axiosInstance.get(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/mutuo-deshacer-recaudacion`, {
    params: { mutuoId }
  });

export const getEsMutuoRecaudable = (mutuoId: number): Promise<AxiosResponse<EsMutuoRecaudableResponse>> =>
  axiosInstance.get<EsMutuoRecaudableResponse>(`${BASE_PATH_API_RECAUDACION}/recaudacionindividual/mutuo-recaudable`, {
    params: { mutuoId }
  });
